import React from 'react';
import './DatePicker.scss';
import {DatePicker as MaterialDatePicker} from '@mui/x-date-pickers/DatePicker';
import {ThemeProvider} from "@mui/material/styles";
import {InputTheme} from "../InputTheme";

/**
 * DatePicker wrapper component that applies project theme
 * @param {Date|null} value - Selected date value
 * @param {Function} onChange - Callback when date changes
 * @param {Function} [shouldDisableDate] - Function to determine if a date should be disabled
 * @param {boolean} [disablePast] - If true, disables past dates
 * @param {Date} [minDate] - Minimum selectable date
 * @param {Date} [maxDate] - Maximum selectable date
 * @param {object} [props] - Additional props passed to Material DatePicker
 */
export const DatePicker = ({value, onChange, shouldDisableDate, disablePast, minDate, maxDate, ...props}) => {
    return <ThemeProvider theme={InputTheme}>
        <MaterialDatePicker
            value={value}
            onChange={onChange}
            shouldDisableDate={shouldDisableDate}
            disablePast={disablePast}
            minDate={minDate}
            maxDate={maxDate}
            {...props}
        />
    </ThemeProvider>

}



